import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import tags from '../../components/ui-components/tags/tags';
import LoadMore from '@components/ui-components/load-more/load-more';
import formGreen from '@components/base/form-green.vue';
import onScrollAnimate from '@assets/js/scrollAnimate.js';
import Card from '@components/ui-components/card/component.js';
import CardVue from '@components/ui-components/card/card.vue';
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            newMedia: [],
            pagination: null,
            disableLoadMore: false,
        }
    },
    components: {
        'tags-cmp': tags,
        'load-more-cmp': LoadMore,
        'form-green-cmp': formGreen,
        'card-cmp': Card,
        'card-vue-cmp': CardVue
    },
    methods: {
        setPagination() {
            setTimeout(() => {
                this.pagination = this.$root.convertTwigToJs("pagination", ".js-pagination");
            }, 100)
        }
    },
    mounted() {
        this.setPagination();
    },
    beforeRouteUpdate(to, from, next) {
        // если не loadMore
        if (!to.query.loadMore) {
            const path = to.path.replace(router.history.base, '');
            this.$root.setDataAnimateFalse();

            Vue.http.get(`templates${path}`, {params: to.query}).then(
                (data) => {
                    next();
                    setTimeout(() => {
                        this.template = data.data;
                        this.setPagination();
                        this.newMedia = [];
                        setTimeout(() => {
                            this.$redrawVueMasonry();
                        }, 10);
                    }, 500);
                },
                () => {
                    next('/404');
                }
            );
        } else {
            this.disableLoadMore = true;
            let url = (process.env.NODE_ENV !== 'production') ?
                'blog/index.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, { params: to.query }).then(
                (data) => {
                    next();
                    this.newMedia = this.newMedia.concat(data.data.items);
                    this.pagination = data.data.pagination;
                    this.disableLoadMore = false;
                    setTimeout(() => {
                        this.$redrawVueMasonry();
                        // setTimeout(() => {
                        //     onScrollAnimate();
                        // }, 100)
                    }, 10);
                },
                () => {
                    this.disableLoadMore = false;
                    next('/404');
                }
            );
        }
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/media/index.js